import { Popover } from "antd";
import React, { useContext } from "react";
import { GiBattery100 } from "react-icons/gi";
import { LAYOUT } from "../../../config/layoutConfig";
import { AppContext } from "../../../context";

function ChargingTime({ chargingTime, size = LAYOUT.ICON_SIZE }) {
  const info = useContext(AppContext);

  return (
    <Popover content={info.t("chargingTime")}>
      <div style={{ textAlign: "center" }}>
        <GiBattery100 style={{ width: size, height: size }} />
        <div>{chargingTime} h</div>
      </div>
    </Popover>
  );
}

export default ChargingTime;
